<!--
 * @Title: 标题
 * @Description: 描述供应链
 * @Author: xulongyong
 * @Date: 2023-09-10 09:18:14
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-11-01 00:47:49
 * @FilePath: \vue-privilege-routing\src\pages\system\system-config\tree-data\type-tree\index.vue
-->
<template>
  <div>
     分类树管理(商品归属,文章归属,项目归属,各种归属)
  </div>
</template>

<script>
export default {
  data() {
      return {}
  }
}
</script>
